import Phaser from 'phaser';
import type { Die, DieColor } from '../types';
import { COLORS } from '../main';

export function dieFillFor(color: DieColor): number {
  switch (color) {
    case 'white':
      return COLORS.white;
    case 'red':
      return COLORS.red;
    case 'blue':
      return COLORS.blue;
  }
}

export function dieTextColor(color: DieColor): string {
  return color === 'white' ? '#0d1117' : '#ffffff';
}

export interface DieGraphics {
  container: Phaser.GameObjects.Container;
  bg: Phaser.GameObjects.Rectangle;
  text: Phaser.GameObjects.Text;
  facesIndicator?: Phaser.GameObjects.Text;
}

export function makeDieSprite(
  scene: Phaser.Scene,
  x: number,
  y: number,
  size: number,
  die: Die
): DieGraphics {
  const container = scene.add.container(x, y);
  const bg = scene.add
    .rectangle(0, 0, size, size, dieFillFor(die.color))
    .setStrokeStyle(2, COLORS.border);
  const text = scene.add
    .text(0, 0, die.value == null ? '?' : String(die.value), {
      fontFamily: 'system-ui, sans-serif',
      fontSize: `${Math.floor(size * 0.55)}px`,
      fontStyle: 'bold',
      color: dieTextColor(die.color),
    })
    .setOrigin(0.5);
  container.add([bg, text]);

  let facesIndicator: Phaser.GameObjects.Text | undefined;
  if (die.faces > 6) {
    facesIndicator = scene.add
      .text(size / 2 - 4, -size / 2 + 4, `d${die.faces}`, {
        fontFamily: 'system-ui, sans-serif',
        fontSize: `${Math.max(8, Math.floor(size * 0.22))}px`,
        color: '#fbbf24',
      })
      .setOrigin(1, 0);
    container.add(facesIndicator);
  }

  return { container, bg, text, facesIndicator };
}
